import { ENDPOINTS } from '../../constants/api'
import { madeRequest } from '../../helpers/api'
import { replaceRouteParams } from '../../helpers/url'

// PLOP_APPEND_PATTERN_ANCHOR

export function getAccessibleSocialPagesService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.accessibleSocialPages
  })
}

export function addAccessibleSocialPagesService(pageData) {
  return madeRequest('POST', {
    data: pageData,
    url: ENDPOINTS.accessibleSocialPages
  })
}

export function deleteAccessibleSocialPagesService(id) {
  return madeRequest('DELETE', {
    url: `${ENDPOINTS.accessibleSocialPages}${id}/`
  })
}

export function getFacebookPagesService(params, skipContextPartnershipId) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.facebookPages,
    skipContextPartnershipId
  })
}

export function getFacebookPageAccessTokenService(params, facebookPageId) {
  return madeRequest('GET', {
    params,
    url: `${ENDPOINTS.facebookPages}${facebookPageId}/access_token/`,
    showErrorToast: false
  })
}

export async function createFacebookPageAccessRequestService(data) {
  return madeRequest('POST', {
    data,
    url: ENDPOINTS.facebookPagesRequestAccess
  })
}

export function getInstagramAccountsService(facebookPageId, params) {
  return madeRequest('GET', {
    url: `${ENDPOINTS.facebookPages}${facebookPageId}/instagram_accounts/`,
    params
  })
}

export function getBackedInstagramAccountsService(facebookPageId, params) {
  return madeRequest('GET', {
    url: `${ENDPOINTS.facebookPages}${facebookPageId}/backed_instagram_accounts/`,
    params
  })
}

export function getFacebookPagesLeadGenFormsService({ id, ...params }) {
  return madeRequest('GET', {
    params,
    url: replaceRouteParams(ENDPOINTS.facebookPagesLeadGenForms, {
      id
    })
  })
}

export function getFacebookDebugTokensService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.facebookDebugTokens
  })
}
